import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchReferralSummary } from '@/services/referrals';

export function useReferralSummary() {
  const { status, session } = useAuthSession();

  return useQuery({
    queryKey: ['referrals', session?.user.id ?? null],
    queryFn: fetchReferralSummary,
    enabled: status === 'ready',
  });
}
